<template>
  <div class="fixedRightBottom">
    <BackTop
      v-if="option.backTop"
      :scroll-container="option.backTop.scrollContainer"
      :item="option.backTop.item"
      :top="option.backTop.top"
      :total="total"
    />
    <Progress class="mt-[12px]" />
    <OnlineService v-if="option.onlineService" class="mt-[12px]" />
  </div>
</template>
<script lang="ts" setup>
import BackTop from './backTop.vue'
import OnlineService from './onlineService.vue'
import Progress from './progress.vue'
import { useFixedRightBottom } from '~/composables/fixedRightBottom'

const option = useFixedRightBottom()

const total = computed(() => {
  if (isRef(option.value.backTop?.total)) {
    return option.value.backTop?.total.value
  }
  return option.value.backTop?.total
})
</script>
<style lang="scss" scoped>
.fixedRightBottom {
  position: fixed;
  right: 10px;
  bottom: 24px;
  z-index: 20;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  html[class*='dark'] & {
    bottom: 84px;
  }
}
</style>
